import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../api';
import DashboardLayout from '../../../Components/Dashboard/DashboardLayout';
import './AdminSuite.css';

const statItems = metrics => [
  { label: 'Students', value: metrics?.total_students ?? 0, icon: '👨‍🎓' },
  { label: 'Courses', value: metrics?.total_courses ?? 0, icon: '📚' },
  { label: 'Pending', value: metrics?.pending_enrollments ?? 0, icon: '⏳' },
  { label: 'Certificates', value: metrics?.certificates_issued ?? 0, icon: '🎓' },
];

const SuperAdminPage = () => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    const load = async () => {
      const res = await api.get('/admin/dashboard/metrics');
      setMetrics(res.data || {});
    };

    load();
  }, []);

  return (
    <DashboardLayout>
      <div className="container py-4 admin-suite">
        <div className="admin-suite-header">
          <div>
            <h3 className="admin-suite-title">Super Admin</h3>
            <p className="admin-suite-subtitle">Platform overview, governance and quick actions.</p>
          </div>
          <Link className="btn btn-primary" to="/admin/users">
            Manage Users
          </Link>
        </div>

        <div className="admin-modern-grid">
          {statItems(metrics).map(item => (
            <div className="admin-modern-card" key={item.label}>
              <div className="admin-modern-icon">{item.icon}</div>
              <div className="admin-modern-label">{item.label}</div>
              <div className="admin-modern-value">{item.value}</div>
            </div>
          ))}
        </div>

        <div className="admin-modern-panel mt-3">
          <h5 className="mb-2">Quick navigation</h5>
          <div className="d-flex flex-wrap gap-2">
            <Link className="btn btn-outline-primary btn-sm" to="/admin/lms">
              LMS Dashboard
            </Link>
            <Link className="btn btn-outline-primary btn-sm" to="/admin/courses">
              Courses
            </Link>
            <Link className="btn btn-outline-primary btn-sm" to="/admin/lms-enrollments">
              Enrollments
            </Link>
            <Link className="btn btn-outline-primary btn-sm" to="/admin/company">
              Company Page
            </Link>
            <Link className="btn btn-outline-primary btn-sm" to="/admin/services">
              Footer Services
            </Link>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SuperAdminPage;
